import toSeoUrl from "@functions/toSeoUrl";

const toMovieUrl = (id, title, venueName = "") => {
    const base = `/movie/${id}/${toSeoUrl(title)}`;
    return venueName ? `${base}?venue_name=${toSeoUrl(venueName)}` : base;
};

export default toMovieUrl;
